import React, { useRef, useEffect } from "react"
import { useLocation } from "@reach/router"
import classNames from "classnames";
import { BgImage } from "gbimage-bridge"
// import Image from "gatsby-image"
// import { Link } from "gatsby"
import { Link } from '@reach/router'
import { graphql, useStaticQuery } from "gatsby"
// import SocialLinks from "../constants/socialLinks"
// ...GatsbyImageSharpFluid
import logo from "../assets/img/logo.svg"
import menuImg from "../assets/img/menu-dots.svg"
import NewsList from "../components/NewsList"
import { IoIosArrowBack } from "react-icons/io"

const TopMenu = () => {
  const {
    allStrapiBlogs: { nodes: blogs },
    allStrapiProducts: { nodes: products },
    // pageContact,
    // pageDistributors
  } = useStaticQuery(graphql`
    {
      allStrapiBlogs(
        sort: { fields: date, order: DESC }
        filter: { hidden: { ne: true } }
        limit: 10
      ) {
        nodes {
          date(formatString: "MMMM Do, YYYY")
          category
          id
          slug
          title
          image {
            childImageSharp {
              gatsbyImageData(
                width: 800
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
        }
      }
      allStrapiProducts(filter: { active: { eq: true } }) {
        nodes {
          id
          new
          slug
          title
          subtitle
          image {
            childImageSharp {
              gatsbyImageData(
                width: 800
                layout: CONSTRAINED
                placeholder: BLURRED
              )
            }
          }
          active
        }
      }
    }
  `)
  /**
   *     pageContact: strapiPages(slug: {eq: "contact"}) {
      id
      slug
      image {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      title
    }
    pageDistributors: strapiPageDistributors {
      info {
        id
        slug
        image {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        title
      }
    }
   */
  const { pathname } = useLocation();

  let [state, setState] = React.useState({ menuActive: false });

  useEffect(() => {
    let headerMenuSolid = false;
    let headerMenuDiv = document.querySelector('.gs-header-menu');
    let headerMsgDiv = document.querySelector('.gs-header-msg--mark');

    let menuHandleScroll = () => {
        let elemRect = headerMsgDiv.getBoundingClientRect();
    
            if ( elemRect.top-80 < 0) {
                    if (headerMenuSolid) return;
                    headerMenuDiv.classList.add('gs-header-menu--solid');
                    headerMenuSolid = true;
            } else {
                if (!headerMenuSolid) return;
                headerMenuSolid = false;
                headerMenuDiv.classList.remove('gs-header-menu--solid');
            }
    }
    window.addEventListener("scroll", menuHandleScroll);
    return () => {
      document.querySelector("body").style.overflow = "auto";
      window.removeEventListener("scroll", menuHandleScroll);
    };
  });

  function openMainMenu() {
    setState({ menuActive: true })
    document.querySelector("body").style.overflow = "hidden"
  }
  function closeMainMenu() {
    setState({ menuActive: false })
    document.querySelector("body").style.overflow = "auto"
  }
  // this is only active when the location pathname is exactly
  // the same as the href.
  const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "gs-modal-menu-link gs-modal-menu-link--active" } : { className: "gs-modal-menu-link" }
  }
  const isActiveSub = ({ isCurrent }) => {
    return isCurrent ? { className: "gs-modal-menu-link gs-modal-menu-link--sub gs-modal-menu-link--active" } : { className: "gs-modal-menu-link gs-modal-menu-link--sub" }
  }

  const newsListRef = useRef();
  function newsScrollRight() {
    newsListRef.current.scrollBy(400, 0);
  }

  function newsScrollLeft() {
    newsListRef.current.scrollBy(-400, 0);
  }

  return (
    <div className="gs-header-menu">
      <div className="gs-header-logo">
        <img className="gs-header-logo__pic" src={logo} alt="logo" />
      </div>
      <div className="gs-flex__spacer"></div>
      <nav className="gs-header-nav">
        <ul className="gs-header-nav__list fw300">
          <li className="gs-header-nav-item">
            <Link to="/" className={classNames({"gs-header-nav__link--active": pathname==="/"}, "gs-header-nav__link")}>Home</Link>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/scanners" className={classNames({"gs-header-nav__link--active": pathname.includes("scanners")}, "gs-header-nav__link")}>
              Scanners
            </Link>
            <div className="gs-header-menu-item-drop gs-header-menu-item-drop--full gs-bg-1">
              <div className="gs-header-menu-item-drop__in">
                <div className="gs-header-menu-item-drop-title">
                  <Link to="/scanners" className="gs-link-alt">
                    <h3>Scanners</h3>
                    <h5 className="fw300">View all</h5>
                  </Link>
                </div>
                <div className="gs-news-list__out">
                  <div className="gs-news-list__holder">
                    <ul className="gs-news-list jcc">
                    {products.map((product)=>{
                      return (
                        <BgImage key={product.id} image={product.image.childImageSharp.gatsbyImageData} Tag="li" className="gs-news-list-item gs-news-list-item--product">
                        <Link to={product.slug}
                          className="gs-news-list-item__link"
                        >
                          <div>
                            <h5 className="gs-news-list__title mb20">
                              {product.title}{" "}
                              {product.new && <span className="gs-news-list__tag ffosw fw300">NEW</span>}
                            </h5>
                            <span className="gs-news-list__subtitle fw300">
                              {product.subtitle}
                            </span>
                          </div>
                        </Link>
                        </BgImage>
                      );
                    })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/videos" className={classNames({"gs-header-nav__link--active": pathname.includes("videos")}, "gs-header-nav__link")}>Videos</Link>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/solutions" className={classNames({"gs-header-nav__link--active": pathname.includes("solutions")}, "gs-header-nav__link")}>Solutions</Link>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/news" className={classNames({"gs-header-nav__link--active": pathname.includes("news")}, "gs-header-nav__link")}>
              News
            </Link>
            <div className="gs-header-menu-item-drop gs-header-menu-item-drop--full gs-bg-1">
              <div className="gs-header-menu-item-drop__in">
                <div className="gs-header-menu-item-drop-title">
                <Link to="/news" className="gs-link-alt">
                  <h3>News &amp; Stories</h3>
                  <h5 className="fw300">View all</h5>
                </Link>
                </div>
                <div className="gs-news-list__out">
                  <IoIosArrowBack className="gs-news-list-arrow" onClick={newsScrollLeft}/>
                  <IoIosArrowBack className="gs-news-list-arrow gs-news-list-arrow--right" onClick={newsScrollRight}/>
                  <div className="gs-news-list__holder" ref={newsListRef}>
                    <NewsList items={blogs} />
                    </div>
                </div>
              </div>
            </div>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/company" className={classNames({"gs-header-nav__link--active": pathname.includes("company")}, "gs-header-nav__link")}>
              Company
            </Link>
          </li>
          <li className="gs-header-nav-item">
            <Link to="/contact" className={classNames({"gs-header-nav__link--active": pathname.includes("contact")}, "gs-header-nav__link")}>
              Contact
            </Link>
          </li>
          {/* <li className="gs-header-nav-item">
            <Link to="/contact" className={classNames({"gs-header-nav__link--active": (pathname.includes("contact") || pathname.includes("distributors"))}, "gs-header-nav__link")}>
              Contact
            </Link>
            <div className="gs-header-menu-item-drop gs-header-menu-item-drop--full gs-bg-1">
              <div className="gs-header-menu-item-drop__in">
                <div className="gs-header-menu-item-drop-title">
                  <h3>Contact</h3>
                </div>
                <div className="gs-news-list__out">
                  <div className="gs-news-list__holder">
                    <ul className="gs-news-list jcc">
                      <BackgroundImage key={pageContact.id} fluid={pageContact.image.childImageSharp.fluid} Tag="li" className="gs-news-list-item gs-news-list-item--product">
                        <Link to={pageContact.slug} className="gs-news-list-item__link">
                          <div>
                            <h5 className="gs-news-list__title mb20">
                              {pageContact.title}{" "}
                            </h5>
                          </div>
                        </Link>
                        </BackgroundImage>
                        <BackgroundImage key={pageDistributors.info.id} fluid={pageDistributors.info.image.childImageSharp.fluid} Tag="li" className="gs-news-list-item gs-news-list-item--product">
                        <Link to={pageDistributors.info.slug} className="gs-news-list-item__link">
                          <div>
                            <h5 className="gs-news-list__title mb20">
                              {pageDistributors.info.title}{" "}
                            </h5>
                          </div>
                        </Link>
                        </BackgroundImage>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li> */}
          <li className="gs-header-nav-item aic">
          <a href="https://grundium.net" target="_blank" rel="noreferrer" className="gs-header-nav__link gs-button fwn">SIGN IN</a>
          </li>
        </ul>
        <button className="gs-header-menu-trigger" onClick={openMainMenu}>
          <img
            src={menuImg}
            className="gs-header-menu-trigger__icon"
            alt="Main menu"
          />
        </button>
      </nav>
      {/* <div className="gs-header-menu-section gs-header-menu-section--news"></div> */}

      <div
          className={
            state.menuActive
              ? "gs-modal-menu gs-modal-menu--active"
              : "gs-modal-menu"
          }
        >
          <button className="gs-modal-menu__close" onClick={closeMainMenu}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="inherit"
              width="100%"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
          <div className="gs-modal-menu-content">
            <div className="gs-modal-menu-links gs-color-contrast mb30">
              <Link
                to="/"
                className="gs-modal-menu-link" getProps={isActive}
              >
                Home
              </Link>
              <Link to="/scanners" className="gs-modal-menu-link" getProps={isActive}>
                Scanners
              </Link>
              {products.map((product, i)=>{
                return <Link to={"/"+product.slug} key={i} className="gs-modal-menu-link gs-modal-menu-link--sub" getProps={isActiveSub} >
                 {product.title}
                </Link>
              })}
              <Link to="/videos" className="gs-modal-menu-link" getProps={isActive}>
                Videos
              </Link>
              <Link to="/solutions" className="gs-modal-menu-link" getProps={isActive}>
                Solutions
              </Link>
              <Link to="/news" className="gs-modal-menu-link" getProps={isActive}>
                News
              </Link>
              <Link to="/company" className="gs-modal-menu-link" getProps={isActive}>
                Company
              </Link>
              {/* <Link to="/distributors" className="gs-modal-menu-link" getProps={isActive}>
                Distributors
              </Link> */}
              <Link to="/contact" className="gs-modal-menu-link" getProps={isActive}>
                Contact
              </Link>
              <a href="https://grundium.net" className="gs-button gs-modal-menu-btn gs-animate--flipInX fwn">SIGN IN</a>
            </div>
          </div>
        </div>

    </div>
  );
  


}

export default TopMenu
